import { useRouter } from 'next/router';
import { EffectCallback, useEffect } from 'react';

export const useOnPathChange = (callback: EffectCallback) => {
  const { asPath } = useRouter();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, [asPath]);
};
